import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function validateCenterCosts(id: number) {
  return restApiClient.url(constructApiUrl(API.centers.validateCenterCosts.url, { id })).post()
}
